// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VHGqi","toggleWrap":"styles_toggleWrap__1T-zR","content":"styles_content__2BUDE","selectAreaCode":"styles_selectAreaCode__16CDU"};